import { TaskListTemplate } from '@awork/features/task/models/task-list-template.model'
import { TaskTemplate } from '@awork/features/task/models/task-template.model'
import { FieldSize } from '../../../_shared/static-data/field-sizes'

export type TaskBundleOperation = 'exportFromProject' | 'exportFromTaskList'

export const TaskBundleNameLimit = FieldSize.SubEntityName
export const TaskBundleDescriptionLimit = FieldSize.Description

/**
 * Task Bundle
 */
export class TaskBundle {
  // TBD: should we make icon, name and description optional?
  id: string
  name: string
  description: string
  icon: string
  taskLists: TaskListTemplate[] = []
  tasks: TaskTemplate[] = []
  isLinkedToProjectTemplate: boolean

  constructor(taskBundle: Partial<TaskBundle>) {
    Object.assign(this, taskBundle)

    this.taskLists = this.taskLists?.map(list => new TaskListTemplate(list))
    this.tasks = this.tasks?.map(task => new TaskTemplate(task))
  }

  /**
   * Returns the count of all tasks of this bundle
   * @returns {number}
   */
  getTaskCount(): number {
    return this.tasks ? this.tasks.length : 0
  }

  /**
   * Returns the count of all task lists of this bundle
   * @returns {number}
   */
  getTaskListCount(): number {
    return this.taskLists?.filter(taskList => taskList.isRealList).length ?? 0
  }
}
